var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { padding: "0 0 32px 32px" } },
    [
      _c("h4", { style: { marginBottom: "20px" } }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "v-chart",
        {
          attrs: {
            "force-fit": true,
            height: _vm.height,
            data: _vm.data,
            scale: _vm.scale,
            onClick: _vm.handleClick
          }
        },
        [
          _c("v-tooltip"),
          _c("v-axis"),
          _c("v-legend"),
          _c("v-line", { attrs: { position: "type*y", color: "x" } }),
          _c("v-point", {
            attrs: {
              position: "type*y",
              color: "x",
              size: 4,
              "v-style": _vm.style,
              shape: "circle"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }